import React from "react";
import { motion } from "framer-motion";
import Card from "./card";
import "./card.css";

export default function CardsBlock({ cards, variant }) {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };
  return (
    <motion.div
      className={`cardsBlock ${variant}`}
      variants={container}
      initial="hidden"
      animate="show"
    >
      {cards.map((cardData, index) => (
        <Card
          key={cardData.id || index} // Используем id или индекс как ключ
          className={cardData.class}
          src={cardData.src}
          title={cardData.title}
          text={cardData.text}
        />
      ))}
    </motion.div>
  );
}
